import { use } from 'react';

import { AbilityContext } from './context';

export const useAbility = () => {
  const ability = use(AbilityContext);

  if (!ability) {
    throw new Error('useAbility must be used inside AbilityProvider');
  }

  return ability;
};
